<template>
	<div class="group maxW">
		<div class="crumbs-link">
			<router-link to="/group">学科圈组</router-link>
			<strong><i>></i>圈组管理</strong>
		</div>
		<div class="group-wp clear">
			<div class="group-list-nav fl">
				<el-menu :default-active="$route.path" class="el-menu-group" router>
					<el-menu-item index="/group/manage/selfCreated">
						<router-link to="/group/manage/selfCreated">
							<i class="ipng group-manage-ipng"></i>
							<span>我创建的圈组</span>
							<i class="el-icon-arrow-right"></i>
						</router-link>
					</el-menu-item>
					<el-menu-item index="/group/manage/iJoin">
						<router-link to="/group/manage/iJoin">
							<i class="ipng group-manage-ipng2"></i>
							<span>我加入的圈组</span>
							<i class="el-icon-arrow-right"></i>
						</router-link>
					</el-menu-item>
				</el-menu>
			</div>
			<div class="group-content">
				<router-view />
			</div>
		</div>
	</div>
</template>
<script>
export default {
    data() {
        return {
					activeIndex:this.$route.path,
        };
    },
    created() {

    },
    mounted(){

    },
    methods: {

    },

};
</script>
